export default "__VITE_ASSET__81c096fb__"